var render = function render(){var _vm=this,_c=_vm._self._c;return _c('shared-actions-panel',_vm._b({ref:"sharedActionsPanel",attrs:{"actions":_vm.preparedActions,"small":_vm.small}},'shared-actions-panel',_vm.additionalProps,false))
}
var staticRenderFns = []

export { render, staticRenderFns }